import { formatLikes, formatViews } from "./format";
import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <article className="group rounded-2xl bg-background-50 border-2 border-background-200 overflow-hidden hover:border-primary-300 hover:shadow-comic transition-all duration-300">
      <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={comic.cover}
          alt={`${comic.title}封面`}
          loading="lazy"
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2 flex flex-wrap gap-1.5">
          {comic.badge && (
            <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-[11px] font-bold">
              {comic.badge}
            </span>
          )}
          <span className="px-2 py-0.5 rounded-full bg-foreground-950/70 text-background-50 text-[11px] backdrop-blur">
            {comic.status}
          </span>
        </div>
      </div>

      <div className="p-3 md:p-4">
        <h3 className="font-heading text-foreground-950 text-sm md:text-base leading-snug truncate">
          {comic.title}
        </h3>
        <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 min-h-[2.5rem]">
          {comic.description}
        </p>

        <div className="flex flex-wrap gap-1.5 mt-3">
          {comic.tags.map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-800 text-[11px]"
            >
              {tag}
            </span>
          ))}
        </div>

        <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-200 text-[11px] md:text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" aria-hidden="true"></i>
            {formatViews(comic.views)} 热度
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-thumb-up-line" aria-hidden="true"></i>
            {formatLikes(comic.likes)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-book-open-line" aria-hidden="true"></i>
            {comic.chapters}话
          </span>
        </div>
      </div>
    </article>
  );
}